export default class {
  constructor() {
    this.hostname = document.location.host.substr(
      document.location.host.indexOf('fenaco.'),
    )
    this.internal = new RegExp(this.hostname, 'i')
    this.attach()
  }

  attach() {
    const links = document.querySelectorAll('.text a')

    for (let i = 0; i < links.length; i++) {
      if (
        !links[i].hasAttribute('target') &&
        !this.internal.test(links[i].host)
      ) {
        links[i].setAttribute('target', '_blank')
        links[i].setAttribute('rel', 'noopener')
      }
    }
  }
}
